"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSalesOrderRefundPayloadObject = exports.createSalesOrderItemFixedObjectPayload = exports.createSalesOrderItemBuiltObjectPayload = exports.createSalesOrderItemsPayloadObject = exports.createRetailCustomerPayloadObject = exports.createRetailLocationPayloadObject = exports.createSalesOrderPayloadObject = void 0;
const TSalesOrderItemType_1 = require("../../../types/TSalesOrderItemType");
/**
 * Functions to create minimal data needed in objects to send to the
 * server. This is for optimisation purposes because for example the serialized sales
 * order object itself can be up to 25kb but this brings it down to about 1kb.
 */
/**
 * Minimise sales order payload. This includes:
 *
 *  - Main sales order fields
 *  - RetailLocation model
 *  - RetailCustomer model
 *  - SalesOrderItem models
 */
function createSalesOrderPayloadObject(salesOrder) {
    const { retailLocation, retailCustomer, salesOrderItems } = salesOrder;
    // we don't remove any of the base field data as it will be essential on the server
    const salesOrderPayloadObject = salesOrder.serialize();
    // minimize order model data to only what's required
    salesOrderPayloadObject.retailLocation = createRetailLocationPayloadObject(retailLocation);
    salesOrderPayloadObject.retailCustomer = createRetailCustomerPayloadObject(retailCustomer);
    salesOrderPayloadObject.salesOrderItems = createSalesOrderItemsPayloadObject(salesOrderItems);
    return salesOrderPayloadObject;
}
exports.createSalesOrderPayloadObject = createSalesOrderPayloadObject;
/**
 * Handle payload optimisation for a retail location. The only thing we care about
 * is the id as we can just look this up on the server and rebuild the model.
 */
function createRetailLocationPayloadObject(retailLocation) {
    return { retailLocationId: retailLocation.retailLocationId };
}
exports.createRetailLocationPayloadObject = createRetailLocationPayloadObject;
/**
 * Handle payload optimisation for a retail customer. The only thing we care about
 * is the id as we can just look this up on the server and rebuild the model.
 */
function createRetailCustomerPayloadObject(retailCustomer) {
    return { retailCustomerId: retailCustomer.retailCustomerId };
}
exports.createRetailCustomerPayloadObject = createRetailCustomerPayloadObject;
/**
 * Handle payload optimisation for different types of sales order items.
 */
function createSalesOrderItemsPayloadObject(salesOrderItems) {
    return salesOrderItems
        .map((salesOrderItem) => {
        // built products
        if (salesOrderItem.type === TSalesOrderItemType_1.TSalesOrderItemType.Built) {
            return createSalesOrderItemBuiltObjectPayload(salesOrderItem);
        }
        // fixed products
        if (salesOrderItem.type === TSalesOrderItemType_1.TSalesOrderItemType.Fixed) {
            return createSalesOrderItemFixedObjectPayload(salesOrderItem);
        }
        // unknown. ignore
        return;
    })
        .filter(p => !!p);
}
exports.createSalesOrderItemsPayloadObject = createSalesOrderItemsPayloadObject;
/**
 * Handle payload optimisation for built products. We only care about product ids as we can use the product list to rebuild the product models as well as the
 * restrictions, pricing rules and availability.
 */
function createSalesOrderItemBuiltObjectPayload(salesOrderItemBuilt) {
    const serializedSalesOrderItemBuilt = salesOrderItemBuilt.serialize();
    serializedSalesOrderItemBuilt.productBlueprint = {
        productId: salesOrderItemBuilt.productId
    };
    serializedSalesOrderItemBuilt.selectedProducts = serializedSalesOrderItemBuilt.selectedProducts.map((selectedProduct) => (Object.assign(Object.assign({}, selectedProduct), { product: { productId: selectedProduct.product.productId } })));
    return serializedSalesOrderItemBuilt;
}
exports.createSalesOrderItemBuiltObjectPayload = createSalesOrderItemBuiltObjectPayload;
/**
 * Handle payload optimisation for fixed products. We only care about product ids as we can use the product list to rebuild the product models.
 */
function createSalesOrderItemFixedObjectPayload(salesOrderItemFixed) {
    const serializedSalesOrderItemFixed = salesOrderItemFixed.serialize();
    serializedSalesOrderItemFixed.product = {
        productId: salesOrderItemFixed.productId
    };
    return serializedSalesOrderItemFixed;
}
exports.createSalesOrderItemFixedObjectPayload = createSalesOrderItemFixedObjectPayload;
/**
 * Minimise sales order refund payload. This includes:
 *
 *  - SalesOrderItem models
 *
 *  The rest of the data is negligible
 */
function createSalesOrderRefundPayloadObject(salesOrderRefund) {
    const { salesOrderRefundProducts } = salesOrderRefund;
    // we don't remove any of the base field data as it will be essential on the server
    const salesOrderRefundPayloadObject = salesOrderRefund.serialize();
    // minimize refund model data to only what's required
    salesOrderRefundPayloadObject.salesOrderRefundProducts = salesOrderRefundProducts.map((salesOrderRefundItem) => (Object.assign(Object.assign({}, salesOrderRefundItem.serialize()), { 
        // sales order items contain large amounts of data
        product: createSalesOrderItemsPayloadObject([
            salesOrderRefundItem.product
        ])[0] })));
    return salesOrderRefundPayloadObject;
}
exports.createSalesOrderRefundPayloadObject = createSalesOrderRefundPayloadObject;
//# sourceMappingURL=createPayloadObjects.js.map